// AI の入力 token を抑えるための上限。注文明細なら 20 行ほどが収まり、
// 400 の errors 配列は通常これより十分短い
const MAX_PAYLOAD_LENGTH = 8000
const SENSITIVE_KEY = /password|token|secret/i

function parseIfJson(text: string): unknown {
  if (!text.startsWith('{') && !text.startsWith('[')) return text
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

function toPlain(value: unknown): unknown {
  if (value instanceof Blob) {
    const name = value instanceof File ? `${value.name}, ` : ''
    return `[file: ${name}${value.type || 'unknown type'}, ${value.size} bytes]`
  }
  if (value instanceof FormData) {
    const fields = [...new Set(value.keys())].map((key) => {
      const values = value.getAll(key).map((v) => (typeof v === 'string' ? parseIfJson(v) : v))
      return [key, values.length === 1 ? values[0] : values]
    })
    return toPlain(Object.fromEntries(fields))
  }
  if (Array.isArray(value)) return value.map(toPlain)
  if (
    typeof value === 'object' &&
    value !== null &&
    Object.getPrototypeOf(value) === Object.prototype
  ) {
    return Object.fromEntries(
      Object.entries(value).map(([key, v]) => [
        key,
        SENSITIVE_KEY.test(key) ? '[REDACTED]' : toPlain(v),
      ]),
    )
  }
  return value
}

// axios の request body は interceptor に届く時点で JSON 文字列・FormData・Blob のいずれか、
// params と response body は object のまま届く
export function summarizePayload(value: unknown): string | undefined {
  if (value === undefined || value === null || value === '') return undefined
  const plain = toPlain(typeof value === 'string' ? parseIfJson(value) : value)
  const text = typeof plain === 'string' ? plain : JSON.stringify(plain)
  // undefined だけを持つ params も JSON では {} になる
  if (text === '{}') return undefined
  if (text.length <= MAX_PAYLOAD_LENGTH) return text
  return `${text.slice(0, MAX_PAYLOAD_LENGTH)}… [truncated, ${text.length} chars in total]`
}
